<template>
    <div class="eda-value"
         :class="{'eda-value--invisible': !visible, 'eda-value-no-max': !maxHeight}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "EdaValue",
        props: {
            visible: {type: Boolean, default: true},
            maxHeight: {type: Boolean, default: true}
        }
    }
</script>

<style scoped>
    .eda-value {
        max-height: 3em;
        opacity: 1;
        overflow: hidden;
        padding: 0.2em 0;
        transition: all 0.2s cubic-bezier(.5,0,0,1);
    }

    .eda-value-no-max{
        max-height: none;
    }

    .eda-value--invisible {
        opacity: 0;
        padding: 0;
        max-height: 0;
    }


</style>